// File: src/components/chat/TypingIndicator/TypingIndicator.tsx
// Purpose: Chat-related UI component

import React from "react";
import styled, { keyframes } from "styled-components";

const dotFlashing = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.3; }
  100% { opacity: 1; }
`;

const TypingContainer = styled.div`
  display: flex;
  gap: 4px;
  padding: ${({ theme }) => theme.spacing.sm};
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${({ theme }) => theme.colors.textSecondary};
  border-radius: 50%;
  animation: ${dotFlashing} 1.2s infinite ease-in-out;
  
  &:nth-child(1) { animation-delay: 0s; }
  &:nth-child(2) { animation-delay: 0.2s; }
  &:nth-child(3) { animation-delay: 0.4s; }
`;

export const TypingIndicator = () => {
  return (
    <TypingContainer>
      <Dot />
      <Dot />
      <Dot />
    </TypingContainer>
  );
};